var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.0002 36.6667C52.1003 36.6667 58.6668 30.1002 58.6668 22C58.6668 13.8999 52.1003 7.33337 44.0002 7.33337C35.9 7.33337 29.3335 13.8999 29.3335 22C29.3335 30.1002 35.9 36.6667 44.0002 36.6667Z",
    stroke: "white",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.324 66C73.3332 65.3979 73.3332 64.7863 73.3332 64.1666C73.3332 55.0539 60.2003 47.6666 43.9998 47.6666C27.7995 47.6666 14.6665 55.0539 14.6665 64.1666C14.6665 73.2794 14.6665 80.6666 43.9998 80.6666C52.1802 80.6666 58.0791 80.0921 62.3332 79.0658",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.49c07b069c35ea506af95cf580ed30dd.svg";
export { ForwardRef as ReactComponent };